import { Box, HStack, Header, Text } from '@rbilabs/universal-components';

import { theme } from 'styles/configure-theme';

export const DeliveryCardContainer = Box.withConfig({
  width: 'full',
});

export const Card = Box.withConfig({
  padding: '22px',
  margin: 0,
  marginBottom: '$4',
  width: 'full',
  backgroundColor: theme.token('background-pattern'),
  borderTopLeftRadius: Styles.borderRadius,
  borderTopRightRadius: Styles.borderRadius,
  borderBottomRightRadius: Styles.borderRadius,
  borderBottomLeftRadius: Styles.borderRadius,

  style: {
    shadowColor: Styles.shadowColor,
    shadowOffset: {
      width: 0,
      height: 0.5,
    },
    shadowRadius: 1.5,
    shadowOpacity: 1,
  },
  focusable: true,
});

export const CardHeading = Header.withConfig({
  variant: 'headerFour',
  color: Styles.color.black,
  fontSize: 'xl',
  lineHeight: 'sm',
  margin: 0,
  textTransform: 'capitalize',
});

export const CardHeadingContainer = Box.withConfig({
  focusable: true,
  padding: '$4',
});

export const TextGroup = Box.withConfig({
  borderBottomWidth: 1,
  borderBottomColor: Styles.color.grey.four,
  paddingBottom: '$4',
  marginBottom: '$4',
  focusable: true,
});

export const CardText = Text.withConfig({
  variant: 'copyOne',
});

export const FeeDeliveryItem = Text.withConfig({
  fontSize: 'sm',
  margin: 0,
  textTransform: Styles.textTransform.headlines,
});

export const TotalRow = HStack.withConfig({
  justifyContent: 'space-between',

  _text: {
    lineHeight: 'xl',
  },
  focusable: true,
});

export const StyledOrderIssues = Box.withConfig({
  alignItems: {
    base: 'center',
    md: 'flex-start',
  },
  marginLeft: {
    base: 'auto',
    md: '$4',
  },
  marginRight: {
    base: 'auto',
    md: '$4',
  },
  width: {
    base: '90%',
    md: 'auto',
  },
  paddingTop: {
    base: '$5',
    md: '$2',
  },
  marginBottom: '$4',
  maxWidth: {
    base: '$96',
    md: 'auto',
  },
  focusable: true,
});

export const ScrollContainer = Box.withConfig({ marginBottom: 'full' });
